import { FC, useState } from 'react';
import { FiArrowRight, FiMapPin } from 'react-icons/fi';

import { TsForm } from '@/components/form/Form';
import { SelectInputField } from '@/components/form/SelectInput';
import { PageSizer, SizerMode } from '@/components/page/PageSizer';
import { Button } from '@/components/shared/button/Button';
import { TSTitleCard } from '@/components/shared/card/Card';
import { createErrorToast } from '@/services/notification/ToastService';
import { useAllLocations } from '@/services/useLocations';
import { useStartManagerDelegation } from '../tenantManagement/useStartManagerDelegation';
import { useForm } from 'react-hook-form';
import strings from './home.translations';

interface AdminLocationForm {
  locationId: string;
}

export const AdminLocationGate: FC = () => {
  const locationList = useAllLocations();
  const startManagerDelegation = useStartManagerDelegation();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const methods = useForm<AdminLocationForm>({
    defaultValues: { locationId: '' }
  });

  const selectedLocationId = methods.watch('locationId');

  const onSubmit = async (data: AdminLocationForm) => {
    const found = locationList.find(l => String(l.id) === data.locationId);
    if (!found || isSubmitting) {
      return;
    }

    try {
      setIsSubmitting(true);
      await startManagerDelegation(found);
    } catch {
      createErrorToast(strings.adminGate.startDelegationError);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <PageSizer mode={SizerMode.PAGE} className="flex-1 overflow-auto">
      <TSTitleCard
        title={strings.adminGate.selectLocation}
        descriptor={strings.adminGate.selectLocationDescriptor}
        icon={FiMapPin}
      >
        <TsForm methods={methods} onSubmit={onSubmit}>
          <div className="flex flex-col space-y-5">
            <SelectInputField
              id="locationId"
              name="locationId"
              label="Location"
              options={[
                { name: strings.adminGate.selectLocation, value: '' },
                ...locationList.map(location => ({
                  name: location.name,
                  value: String(location.id)
                }))
              ]}
            />

            <div className="flex w-full items-center justify-end">
              <Button
                primary
                type="submit"
                disabled={!selectedLocationId || isSubmitting}
                className="flex-1 flex items-center justify-center gap-2"
              >
                {isSubmitting ? strings.adminGate.continueLoading : strings.adminGate.continue}
                <FiArrowRight className="w-4 h-4" />
              </Button>
            </div>
          </div>
        </TsForm>
      </TSTitleCard>
    </PageSizer>
  );
};
